import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useContext } from 'react';
import { AuthContext } from '../contexts/AuthContext';
import finbaseLogo from '../assets/logos/finbase-logo.svg';
import '../styles/Header.css';
import { getHostKind } from '../utils/host';

const Header = () => {
  const { token, logout } = useContext(AuthContext);
  const location = useLocation();
  const hostKind = getHostKind();
  const hideAuthActions = ['/', '/login', '/signup', '/password-reset', '/invite'].includes(location.pathname);
  const portalName = hostKind === 'ops' ? 'Admin Portal' : 'Account Management';
  const portalHomePath = hostKind === 'ops' ? '/admin' : '/account/overview';

  const handleLogout = async () => {
    await logout();
  };

  if (hostKind === 'id') return null;

  return (
    <header className="app-header d-flex justify-content-between align-items-center flex-wrap px-3 py-2">
      <div className="d-flex align-items-center gap-2 header-brand">
        <Link to={portalHomePath} className="app-logo-link" aria-label={`${portalName} home`}>
          <img src={finbaseLogo} alt="Finbase" className="app-logo" />
        </Link>
        <span className="portal-divider" aria-hidden="true"></span>
        <span className="portal-name">{portalName}</span>
      </div>
      {token && !hideAuthActions && (
        <div className="header-actions">
          <button onClick={handleLogout} className="btn header-btn header-btn-outline">
            <i className="fas fa-sign-out-alt" aria-hidden="true"></i>
            <span className="header-btn-text">Log Out</span>
          </button>
        </div>
      )}
    </header>
  );
};

export default Header;
